// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".news-detail[data-v-5b3aa3da] {\n  height: 100%;\n}\n.result-card[data-v-5b3aa3da] {\n  height: 100%;\n}\n[data-v-5b3aa3da] .category-item .ant-form-item-children {\n  position: relative;\n}", ""]);
// Exports
module.exports = exports;
